import { apiRequest } from '@/utils/api-request';

export interface OrgBillingConfig {
  orgid: string;
  markup_percentage: number;
  updated_at?: string;
  updated_by?: string;
}

export const updateBillingConfig = async (
  orgId: string,
  markupPercentage: number,
): Promise<OrgBillingConfig> => {
  const response = await apiRequest<OrgBillingConfig>({
    url: `/organizations/${orgId}/billing-config`,
    method: 'PUT',
    target: 'platform',
    body: { markup_percentage: markupPercentage },
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  if (!response?.data) {
    throw new Error('Unexpected response format');
  }

  return response.data;
};
